import React, { useEffect } from "react";

function OnlineService() {
	useEffect(() => {
		const script = document.createElement('script');

		if (process.env.REACT_APP_DEV_ENV === "dev")
			script.src = "https://s3.hicloud.net.tw/cpmaker-stg/b75aff59-2634-45b2-ae41-764f60b1bbc2.js";
		else if (process.env.REACT_APP_DEV_ENV === "stage")
			script.src = "https://s3.hicloud.net.tw/cpmaker-stg/b75aff59-2634-45b2-ae41-764f60b1bbc2.js";
		else if (process.env.REACT_APP_DEV_ENV === "prod")
			script.src = "https://s3.hicloud.net.tw/cpmaker/988fa3ee-e5ef-4bf9-82ff-32f2ea832f16.js";

		script.async = true;
		document.body.appendChild(script);
		return () => {
			document.body.removeChild(script);
		}
	}, []);

	return (
		<></>
	)
}

export default OnlineService;